import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from '../layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import { Formik } from 'formik';

import {Loading} from "../custom-icons";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import axios from 'axios';  

import {APP_URL, APP_NAME , IMG_URL, API_ENDPOINT, toast_anim , pdfdoconly , hospital_regOptions, date_format} from '../components/config/Common'
import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from '../routes/ScrollPageTop'

import { yupResolver } from '@hookform/resolvers/yup';
import Input from '../ui/input.jsx'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import SelectInput from '../ui/select-input.jsx'
import Label from '../ui/label.tsx'
import Button from '../ui/Button.tsx'
import TextArea from '../ui/text-area.tsx'

import {
    Control,
    FieldErrors,
    useForm,
    useFormState,
    useWatch,
    Controller
 } from 'react-hook-form';

const SignupSchema = Yup.object().shape({
    subject: Yup.string()
        .required('You must need to provide Subject.'),    
    message: Yup.string()
        .required('You must need to provide your query.'),		
});

let defaultValues = {  
	subject: '',
	message: '',
};

const HospitalQuery = () => {

    const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
    const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
    const [user_me, setUser_me] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hospital_query_list, setHospital_query_list] = useState([]);
    const [isFetch, setIsFetch] = useState(false);

    const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
            defaultValues: defaultValues,
            resolver: yupResolver(SignupSchema),
        });

    const onSubmit = (values) => {
		//console.log('value===', values)

        let input = {
            subject: values.subject,
            message: values.message,
        }

        //console.log('input===', input)

        setLoading(true)
        axios.post(`${API_ENDPOINT}/insert_hospital_query`, input, {
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+access_token, 
            }
        }).then(function (response) {
                setLoading(false)
                setIsFetch(true)
                //console.log('response===', response)
                toast.success(response.data.message, toast_anim);
                reset(defaultValues)
        }).catch(function (error) {
            setLoading(false)
            if(error.response){
                if(error.response.status === 422){
                    let errors = error.response.data.errors
                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            setError(key, { type: 'server', message: errors[key][0] });
                        }
                    }
                    setError('subject', { type: 'server', message: error.response.data.message });
                    toast.error(error.response.data.message, toast_anim);
                }else{
                    toast.error(error.response.data.message, toast_anim);
                }
            }else{
                toast.error('Something went wrong. Please try again.', toast_anim);
            }
        });
	}

    const hospital_query_listing = () => {
        setLoading(true)
        axios.get(`${API_ENDPOINT}/hospital_query_listing`, {
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+access_token, 
            }
        }).then(function (response) {
                setLoading(false)
                console.log('response===:', response)

                setHospital_query_list(response.data.data)
        }).catch(function (error) {
            setLoading(false)
            if(error.response){
                toast.error(error.response.data.message, toast_anim);
            }else{
                toast.error('Something went wrong. Please try again.', toast_anim);
            }
        });
    }

    useEffect(() => {
        //if(access_token && user_type === 'hospital'){
            hospital_query_listing()
        //}
    }, [isFetch])
    

    const siteMetadata = {
        url: `${APP_URL}/raise-query`,
        title:  `Raise Query - ${APP_NAME}`,
        description: `Raise Query ctmrihub`,
    };

    return (
		<ScrollPageTop>
			<ReactSEOMetaTags
				render={(el: React.ReactNode) => <Helmet>{el}</Helmet>}
				website={{ ...siteMetadata }}
				breadcrumb={[
					{ title: 'Home', url: `${APP_URL}` },
					{ title: 'Raise Query', url: `${APP_URL}/raise-query` },
				]}
			/>
         <LeftMenuLayout>
            <>
            <div className="w-full">
                <div className={classNames('w-full p-5 md:p-8 bg-light dark:bg-gray-700 shadow rounded mb-8')}>
                    <p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Raise your query</p>
                    
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Input                
                            label={`Subject`}
                            {...register('subject')}
                            variant="outline"
                            className="mb-5"
                            type="text"
                            error={errors.subject?.message}
                            required
                        />
                        <TextArea
                            label={`Your Query`}
                            {...register('message')}
                            variant="outline"
                            className="mb-5"
                            error={errors.message?.message}
                            required
                        />
                        <Button loading={loading} type="submit" className="w-full md:w-auto">Submit Query</Button>  
                    
                    </form>
                </div>

                <div className={classNames('w-full p-5 md:p-8 bg-light dark:bg-gray-700 shadow rounded mb-8')}>
                    <p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Your Previous Queries</p>
                    <table className="table-auto w-full text-left border">
                        <thead className="bg-gray-300">
                            <tr>
                                <th className="border px-4 py-2">Subject</th>
                                <th className="border px-4 py-2">Query</th>
                                <th className="border px-4 py-2">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {hospital_query_list && hospital_query_list.length > 0 && hospital_query_list.map((item, index) => (
                                <tr key={index}>
                                    <td className="border px-4 py-2">{item.subject}</td>
                                    <td className="border px-4 py-2">
                                        
                                        <div style={{ whiteSpace: "pre-line" }}>
                                        {item.message}
                                        </div>
                                    </td>
                                    <td className="border px-4 py-2">{date_format(item.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            
            </>
         </LeftMenuLayout>
        </ScrollPageTop>
    );

}

export default HospitalQuery;